import { render, staticRenderFns } from "./ImportsTenantHistory.vue?vue&type=template&id=e46f7c92"
import script from "./ImportsTenantHistory.vue?vue&type=script&lang=js"
export * from "./ImportsTenantHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports